import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const clearTranslationCache = api(async function clearTranslationCache({ language }) {
    return mutate(
        gql`
            mutation ClearTranslationCache($language: String) {
                clearTranslationCache(language: $language)
            }
        `,
        { language },
        { returns: "clearTranslationCache" }
    )
})
